import React from 'react';

class ArrowIcon extends React.Component {
  render() {
    return (
      <svg
        width="20"
        height="10"
        viewBox="0 0 20 10"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20 2H0V0H20V2ZM0 4H20V6H0V4ZM0 8H20V10H0V8Z"
          fill="#8A8B8D"
        />
      </svg>
    );
  }
}

export default ArrowIcon;
